// extracted by mini-css-extract-plugin
export default {"buttonOpenUploader":"ButtonOpenUploader_buttonOpenUploader__Fxnii","icon":"ButtonOpenUploader_icon__vl-Fx"};